import { render, staticRenderFns } from "./PlanUpgradeNeededBanner.vue?vue&type=template&id=2736dd31&scoped=true&"
import script from "./PlanUpgradeNeededBanner.vue?vue&type=script&lang=js&"
export * from "./PlanUpgradeNeededBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlanUpgradeNeededBanner.vue?vue&type=style&index=0&id=2736dd31&prod&lang=css&"
import style1 from "./PlanUpgradeNeededBanner.vue?vue&type=style&index=1&id=2736dd31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736dd31",
  null
  
)

export default component.exports